import { render, staticRenderFns } from "./IconCosts.vue?vue&type=template&id=d902b188"
import script from "./IconCosts.vue?vue&type=script&lang=js"
export * from "./IconCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports